// src/components/profile/EmptyStatePrompt.jsx
import React from 'react';

const EmptyStatePrompt = ({ section, onAdd }) => {
  return (
    <div className="bg-dark-gray/20 border border-gray-700 rounded-lg p-6 text-center">
      <p className="text-gray-400 mb-4">You haven't added any {section.toLowerCase()} information yet.</p>
      <button
        onClick={onAdd}
        className="bg-primary hover:bg-blue-600 text-white px-4 py-2 rounded-md transition-colors"
      >
        Add {section} Information
      </button>
    </div>
  );
};

export default EmptyStatePrompt;
